import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Row,
} from "reactstrap";
import { useHistory, useParams, Link } from "react-router-dom";
import { useGetInstence } from "../../../hooks/useGetInstence";
import { useState } from "react";
import { getCompany } from "../../../api/companies";
import Breadcrumb from "../../../components/Common/Breadcrumb";
import ResultHandler from "../../../components/ResultHandler";
import ContactsTable from "./contacts/ContactsTable";
import ContractsTable from "./contracts/ContractsTable";
import "./CompanyProfile.css";
import FeesTable from "./fees/FeesTable";
import PriceComponentsTable from "../price-components/PriceComponentsTable";
import RelatedPriceComponentsTable from "../price-components/RelatedPriceComponentsTable";
import { formatCurrency } from "../../../utils/formatCurrency";
import { startedCompanyId } from "../../../utils/constants";
import { PERMISSIONS } from "../../../api/permissions";

export default function CompanyProfile({}) {
  const navigate = useHistory();
  const params = useParams();
  const [company, setCompany] = useState(null);
  const [financeFeesPriceComponent, setFinanceFeesPriceComponent] =
    useState(null);

  const { instenceLoading, instenceError, instenceSuccess } = useGetInstence(
    getCompany,
    params.id,
    (response) => {
      setCompany({ ...response.data.data.company });
      if (response.data.data.financeFeesPriceComponent !== null) {
        setFinanceFeesPriceComponent({
          ...response.data.data.financeFeesPriceComponent,
        });
      }
    }
  );

  const [infoOpen, setInfoOpen] = useState("open");
  const [financialInfoOpen, setFinancialInfoOpen] = useState("open");
  const [contactsOpen, setContactsOpen] = useState("open");
  const [contractsOpen, setContractsOpen] = useState("open");
  const [feesOpen, setFeesOpen] = useState("open");
  const [priceComponentsOpen, setPriceComponentsOpen] = useState("open");

  const permissions = JSON.parse(localStorage.getItem("permissions")) || [];

  return (
    <div className="page-content company-profile-page">
      <div className="container-fluid">
        <Breadcrumb title="" breadcrumbItem={"Company Profile"} />
        <ResultHandler loading={instenceLoading} />

        <Container fluid>
          {company && (
            <Row>
              <Col md={12} style={{ marginBottom: "20px" }}>
                <Accordion
                  open={infoOpen}
                  toggle={() => setInfoOpen((i) => (i ? null : "open"))}
                >
                  <AccordionItem>
                    <AccordionHeader targetId="open">
                      Company Information #{startedCompanyId + company.id}
                    </AccordionHeader>
                    <AccordionBody
                      style={{ backgroundColor: "white" }}
                      accordionId="open"
                    >
                      <div
                        className="d-flex mb-2"
                        style={{ justifyContent: "space-between" }}
                      >
                        <div style={{ fontWeight: "bold" }}>
                          Client name: {company.name}
                        </div>
                        <div>Accounting Id: {company.accountingId}</div>
                      </div>
                      <div>
                        Visit address: {company.house_number} {company.street},{" "}
                        {company.city}, {company.zip_code}
                      </div>
                      <div>
                        Postal address: {company.postal_address_house_number}{" "}
                        {company.postal_address_street},{" "}
                        {company.postal_address_city},{" "}
                        {company.postal_address_zip_code}
                      </div>
                      <div>email: {company.invoice_email} </div>
                      <div>
                        Three Party Agreement:
                        {company.threePartyAgreement && (
                          <a
                            href={company.threePartyAgreement}
                            className="ms-2 text-info fw-bold"
                          >
                            Download
                          </a>
                        )}
                      </div>
                      <div>
                        Mandate:
                        {company.mandate && (
                          <a
                            href={company.mandate}
                            className="ms-2 text-info fw-bold"
                          >
                            Download
                          </a>
                        )}
                      </div>
                      <div
                        className="d-flex"
                        style={{ justifyContent: "flex-end" }}
                      >
                        <Button
                          color="dark"
                          onClick={() =>
                            navigate.push("/edit-company/" + params.id + "/all")
                          }
                        >
                          Edit
                        </Button>
                      </div>
                    </AccordionBody>
                  </AccordionItem>
                </Accordion>
              </Col>

              <Col md={12} style={{ marginBottom: "20px" }}>
                <Accordion
                  open={financialInfoOpen}
                  toggle={() =>
                    setFinancialInfoOpen((i) => (i ? null : "open"))
                  }
                >
                  <AccordionItem>
                    <AccordionHeader targetId="open">
                      Financial Information
                    </AccordionHeader>
                    <AccordionBody
                      style={{ backgroundColor: "white" }}
                      accordionId="open"
                    >
                      <div
                        className="d-flex mb-2 flex-wrap flex-column flex-sm-row gap-x-3 text-info"
                        style={{
                          justifyContent: "space-between",
                        }}
                      >
                        <div className="fw-bold">
                          Credit line: {company.creditLine ? "Yes" : "No"}
                        </div>
                        <div className="fw-bold">
                          Master amount: {formatCurrency(company.amount)}
                        </div>
                        <div className="fw-bold">
                          Master current: {formatCurrency(company.current)}
                        </div>
                        <div className="fw-bold">
                          Unpaid amount: {formatCurrency(company.unpaidAmount)}
                        </div>
                      </div>
                      <div>Payment terms: {company.paymentTerms}</div>
                      <div>Credit insurance: {company.creditInsurance}</div>
                      <div>Credit fee: {company.creditInsuranceFee}%</div>
                      {financeFeesPriceComponent &&
                        permissions.includes(
                          PERMISSIONS.FINANCE_FEES_CHECKBOX
                        ) && (
                          <div>
                            <span>
                              Finance fee: {financeFeesPriceComponent.amount}
                              {financeFeesPriceComponent.priceComponent
                                ?.amount_type == "percentage"
                                ? "%"
                                : "€"}
                            </span>
                            <Link
                              to={`/edit-price-component/${financeFeesPriceComponent.priceComponent?.id}`}
                              className="text-decoration-underline ms-2"
                              style={{ color: "#227afb" }}
                            >
                              Edit
                            </Link>
                          </div>
                        )}
                      <div>Accounting Id: {company.accountingId}</div>
                      <div
                        className="d-flex"
                        style={{ justifyContent: "flex-end" }}
                      >
                        <Button
                          color="dark"
                          onClick={() =>
                            navigate.push(
                              "/edit-company/" + params.id + "/master"
                            )
                          }
                        >
                          Edit
                        </Button>
                      </div>
                    </AccordionBody>
                  </AccordionItem>
                </Accordion>
              </Col>

              <Col md={12} style={{ marginBottom: "20px" }}>
                <Accordion
                  open={contactsOpen}
                  toggle={() => setContactsOpen((i) => (i ? null : "open"))}
                >
                  <AccordionItem>
                    <AccordionHeader targetId="open">Contacts</AccordionHeader>
                    <AccordionBody
                      style={{ backgroundColor: "white" }}
                      accordionId="open"
                    >
                      <ContactsTable hideTableHeader />

                      <div
                        className="d-flex"
                        style={{
                          justifyContent: "flex-end",
                          marginTop: "20px",
                        }}
                      >
                        <Button
                          color="dark"
                          onClick={() =>
                            navigate.push(
                              "/company/" + params.id + "/add-contact"
                            )
                          }
                        >
                          Add
                        </Button>
                      </div>
                    </AccordionBody>
                  </AccordionItem>
                </Accordion>
              </Col>

              <Col md={12} style={{ marginBottom: "20px" }}>
                <Accordion
                  open={contractsOpen}
                  toggle={() => setContractsOpen((i) => (i ? null : "open"))}
                >
                  <AccordionItem>
                    <AccordionHeader targetId="open">Contracts</AccordionHeader>
                    <AccordionBody
                      style={{ backgroundColor: "white" }}
                      accordionId="open"
                    >
                      <ContractsTable hideTableHeader />

                      <div
                        className="d-flex"
                        style={{
                          justifyContent: "flex-end",
                          marginTop: "20px",
                        }}
                      >
                        <Button
                          color="dark"
                          onClick={() =>
                            navigate.push(
                              "/company/" + params.id + "/add-contract"
                            )
                          }
                        >
                          Add
                        </Button>
                      </div>
                    </AccordionBody>
                  </AccordionItem>
                </Accordion>
              </Col>

              {/*<Col md={12} style={{marginBottom: "20px"}}>
                            <Accordion open={feesOpen} toggle={() => setFeesOpen(i => i ? null : "open" )}>
                                <AccordionItem>
                                    <AccordionHeader targetId="open">
                                    Base Fee Structure
                                    </AccordionHeader>
                                    <AccordionBody style={{backgroundColor: "white"}} accordionId="open">
                                        <FeesTable hideTableHeader hideTableAction />

                                        <div className="d-flex" style={{justifyContent: "flex-end", marginTop: "20px"}}>
                                            <Button color="dark" onClick={() => navigate.push('/company/'+params.id+'/fees')}>Edit</Button>
                                        </div>
                                    </AccordionBody>
                                </AccordionItem>
                            </Accordion>
                        </Col>*/}

              <Col md={12} style={{ marginBottom: "20px" }}>
                <Accordion
                  open={priceComponentsOpen}
                  toggle={() =>
                    setPriceComponentsOpen((i) => (i ? null : "open"))
                  }
                >
                  <AccordionItem>
                    <AccordionHeader targetId="open">
                      Base Fee Structure
                    </AccordionHeader>
                    <AccordionBody
                      style={{ backgroundColor: "white" }}
                      accordionId="open"
                    >
                      <RelatedPriceComponentsTable
                        type="companies"
                        relatedId={params.id}
                        hideTableHeader
                      />
                    </AccordionBody>
                  </AccordionItem>
                </Accordion>
              </Col>
            </Row>
          )}
        </Container>
      </div>
    </div>
  );
}
